module.exports = __webpack_public_path__ + "static/media/logo.592296e3.png";